import { http } from './config'

export default {
  listarloja:() => {
    return http.get('loja.php')
  },
}